import languages from '../../@generated/languages.json';

type LanguageCode = keyof typeof languages;

const languageCodes = Object.keys(languages) as LanguageCode[];
const DEFAULT_LANGUAGE: LanguageCode = 'en';

function getSupportedLanguageCode(value?: string | null): LanguageCode | null {
  if (!value) {
    return null;
  }

  const languageCode = value.toLowerCase().split(/[-_]/)[0];
  const candidate = (
    languageCode === 'nb' || languageCode === 'nn' ? 'no' : languageCode
  ) as LanguageCode;

  return languageCodes.includes(candidate) ? candidate : null;
}

function getSafeLanguageCode(value?: string | null): LanguageCode {
  return getSupportedLanguageCode(value) ?? DEFAULT_LANGUAGE;
}

export {
  languages,
  languageCodes,
  DEFAULT_LANGUAGE,
  getSafeLanguageCode,
  getSupportedLanguageCode,
  type LanguageCode,
};
